import React from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { SidePanel, SidePanelProps } from '@brighterion/br-ui';
import { getSidePanelIsOpen } from 'Selectors';
import useSidePanel from 'Hooks/reduxHelperHooks/useSidePanel';
import { useListFilesDownloadStore } from 'Hooks/zustand/useListFilesDownloadStore';
import SidePanelContent from './SidePanelContent/SidePanelContent';
import ListFileDownloadManager from './ListFileDownloadManager';

const ImportExportSidePanel = () => {
    const { closeImportExportQueue } = useSidePanel();
    const isSidePanelOpen = useSelector(getSidePanelIsOpen);
    const { filesDownloading } = useListFilesDownloadStore();
    const children = <SidePanelContent />;

    const importExportQueueProps: SidePanelProps = {
        closeModal: closeImportExportQueue,
        modal: {
            id: 'importExportQueue',
            name: 'import-export-queue',
            title: t('Imports and Exports')
        },
        options: {
            isOpen: isSidePanelOpen,
            customStatusIcon: 'cloud-arrow-down-outline',
            showCloseIcon: true
        },
        children
    };
    // download list files //
    const onGoingListFileDownloads = React.useCallback(() => {
        const downloadComponents = filesDownloading.map((download) => {
            return <ListFileDownloadManager key={download.id} fileToDownload={download} />;
        });
        return downloadComponents;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filesDownloading.length]);

    return (
        <>
            <SidePanel {...importExportQueueProps} />
            {onGoingListFileDownloads()}
        </>
    );
};

export default ImportExportSidePanel;
